import { Box, useTheme } from '@mui/material';
import React from 'react';
import { ITheme, ThemeMode } from 'types/theme';
import { getTaskColor } from '@utils/flows';
import { IFlowInteractionGroup, ITaskInteraction } from 'types/flows';
import ActionTypeIcon from './ActionTypeIcon';
import ActionOutputLabel from './ActionOutputLabel';
import ActionOutputBlockHandle from './ActionOutputBlockHandle';
import ActionOutputBlockGroup from './ActionOutputBlockGroup';

const ActionOutputBlock = ({
	parentId,
	selected,
	interaction
}: {
	parentId: string;
	selected: boolean;
	interaction: ITaskInteraction;
}) => {
	const theme = useTheme<ITheme>();
	const color = getTaskColor(theme, interaction.nextTask?.type);
	const interactionGroup = interaction as IFlowInteractionGroup;

	return (
		<Box
			position="relative"
			display="flex"
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			border={theme.palette.mode === ThemeMode.dark ? 1 : 0}
			borderRadius={1}
			borderColor={theme.palette.border.main}
			bgcolor={theme.palette.card.main}
		>
			{interactionGroup.interactions?.length > 0 &&
			interactionGroup.isCollapsible ? (
				<ActionOutputBlockGroup interactionGroup={interactionGroup} />
			) : (
				<Box
					display="flex"
					flexGrow={1}
					flexDirection="row"
					alignItems="center"
					p={2}
					overflow="hidden"
					data-testid={`node-${parentId}-interaction-${interaction.id}`}
				>
					{(interaction.icon || interaction.type) && (
						<Box
							width={24}
							display="flex"
							alignItems="center"
							justifyContent="flex-start"
						>
							<ActionTypeIcon
								actionType={interaction.icon || interaction.type}
							/>
						</Box>
					)}
					<ActionOutputLabel
						interaction={interaction}
						label={interaction.label}
					/>
				</Box>
			)}
			<ActionOutputBlockHandle
				interactionId={interaction.id}
				parentId={parentId}
				isConnected={!!interaction.nextTask}
				selected={selected}
				color={
					interaction.nextTask && selected ? color : theme.palette.text.disabled
				}
			/>
		</Box>
	);
};

export default ActionOutputBlock;
